const styles = theme => ({
    list: {
        marginBottom: theme.spacing.unit * 2
    }
});

export default styles;
